import { createContext, useContext } from "react";
import { MapsLocale } from "./MapsLocale";
import {
    FALLBACK_I18N_TEXTS_LOCALE_CODE,
    type I18nTextsLocaleCode,
} from "./types";

export type CurrentLocaleProviderContextValue = {
    i18nTextsLocaleCode: I18nTextsLocaleCode;
    locale: MapsLocale;
    localeCodeForMatlocqRequests: string;
    localeIsFallbackLocale: boolean;
};

export const CurrentLocaleProviderContext =
    createContext<CurrentLocaleProviderContextValue>({
        i18nTextsLocaleCode: FALLBACK_I18N_TEXTS_LOCALE_CODE,
        locale: new MapsLocale(FALLBACK_I18N_TEXTS_LOCALE_CODE, false),
        localeCodeForMatlocqRequests: FALLBACK_I18N_TEXTS_LOCALE_CODE,
        localeIsFallbackLocale: true,
    });

export function useCurrentLocale() {
    return useContext(CurrentLocaleProviderContext);
}
